var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgUpperFace = function SvgUpperFace(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    d: "M10.163 6.194c0 .375.882-.075-3.038 1.306s-4.51 6.061-3.89 7.5C-.009 3.673 6 2.25 8.811 2.74m1.352 3.454c-.901-.737-2.433-2.46-1.352-3.453m1.352 3.453a9.99 9.99 0 0 1 4.506 7.802l.04.698c.003.063.088.076.106.016C16.2 10.084 16.34 1.526 8.811 2.74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M13.57 12.327a1.6 1.6 0 0 0-.625-.41A2.7 2.7 0 0 0 12 11.75c-.338 0-.665.06-.945.168a1.6 1.6 0 0 0-.626.41M7.57 12.327a1.6 1.6 0 0 0-.625-.41A2.7 2.7 0 0 0 6 11.75c-.338 0-.665.06-.945.168a1.6 1.6 0 0 0-.626.41"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUpperFace);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;